import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
export var getCssFromStyle = function(style) {
    var css = {};
    if (style === undefined) {
        return css;
    }
    var background_color = style.background_color, border_color = style.border_color;
    if (background_color) {
        css["backgroundColor"] = getSlateColorToken(background_color, undefined);
    }
    if (border_color) {
        css["border"] = "1px solid ".concat(getSlateColorToken(border_color, undefined));
    }
    return css;
};
